import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import LoadingSpinnerIcon from '@icons/LoadingSpinnerIcon';
import colors from '@general/colors';

const LoadingContainer = styled.div`
    align-items: start;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
`;

const LoadingInline = ({ minHeight = 600 }) => (
    <LoadingContainer minHeight={minHeight}>
        <LoadingSpinnerIcon fill={colors.darkGray} />
    </LoadingContainer>
);

LoadingInline.propTypes = {
    minHeight: PropTypes.number,
};

export default LoadingInline;
